<template>
    <div>
        <zm-row>
            <zm-col :span="16">
                <span>from:</span>
                <zm-date-picker size="small"
                    v-model="filter.from"
                    type="date"
                    class="date-in-line"
                    clear-icon="zm-icon-error"
                    clearable
                    format="yyyy-MM-dd"
                    @change="onDateChange"
                    :picker-options="fromDatePickerOption"
                    value-format="yyyy-MM-dd"></zm-date-picker>
                <span>to:</span>
                <zm-date-picker size="small"
                    v-model="filter.to"
                    type="date"
                    class="date-in-line"
                    clearable
                    clear-icon="zm-icon-error"
                    format="yyyy-MM-dd"
                    :picker-options="toDatePickerOption"
                    @change="onDateChange"
                    value-format="yyyy-MM-dd"></zm-date-picker>
                    <a href="#" @click="setDate(0)">today</a>/
                    <a href="#" @click="setDate(1)">last 3 days</a>/
                    <a href="#" @click="setDate(2)">last week</a>
            </zm-col>
            <zm-col :span="8">
            <zm-radio-group v-model="activeChart" buttonStyle class="select-chart" @change="onChange">
                <zm-radio label="total"></zm-radio>
                <zm-radio label="days"></zm-radio>
                <zm-radio label="topics"></zm-radio>
                <zm-radio label="users"></zm-radio>
            </zm-radio-group>
            </zm-col>
        </zm-row>
        <zm-row>
            <zm-select size="small"
                class="select-chart select-with-prefix"
                v-model="groupSelected"
                filterable
                autocomplete="off"
                v-if="activeChart === 'topics'">
                <template slot="prefix">
                    <zm-tooltip class="item" content="select group" placement="bottom" slot="suffix">
                        <i class="zm-icon-help-outline zm-input__icon" style="line-height: 10px;"></i>
                    </zm-tooltip>
                </template>
                <zm-option
                v-for="(item, index) in chartData2"
                :key="item.label"
                :label="item.label"
                :value="index">
                </zm-option>
            </zm-select>
            <zm-select size="small"
                class="select-chart select-with-prefix"
                v-model="selectTopic"
                filterable
                clearable
                autocomplete="off"
                v-if="activeChart === 'topics'"
                @change="fetchTopicData">
                <template slot="prefix">
                    <zm-tooltip class="item" content="select topic" placement="bottom" slot="suffix">
                        <i class="zm-icon-help-outline zm-input__icon" style="line-height: 10px;"></i>
                    </zm-tooltip>
                </template>
                <zm-option
                v-for="item in topicList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
                </zm-option>
            </zm-select>
            <zm-select size="small"
                class="select-chart select-with-prefix"
                v-model="selectUser"
                filterable
                clearable
                autocomplete="off"
                v-if="activeChart === 'users'"
                @change="fetchUserData">
                <template slot="prefix">
                    <zm-tooltip class="item" content="select user" placement="bottom" slot="suffix">
                        <i class="zm-icon-help-outline zm-input__icon" style="line-height: 10px;"></i>
                    </zm-tooltip>
                </template>
                <zm-option
                v-for="item in userList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
                </zm-option>
            </zm-select>
        </zm-row>
        <div class="table-container" style="height: calc(100vh - 320px)">
            <ve-histogram :data="chartData" :settings="chartSetting" v-if="activeChart === 'total' || activeChart === 'users'"
            width="99%" height="100%"
            :tooltip-visible="false" :extend="chartExtend" :colors="colors"></ve-histogram>
            <ve-line :data="daysData" :colors="colors" v-if="activeChart === 'days'"
            width="99%" height="100%"></ve-line>
            <zm-row style="height: calc(100vh - 320px)" v-show="activeChart === 'topics'">
                <zm-col :span="12" style="height: calc(100vh - 320px)">
                    <ve-histogram :data="chartData" :settings="chartSetting"
                        width="99%" height="100%" :colors="colors" v-if="activeChart === 'topics'"
                        :tooltip-visible="false" :extend="chartExtend">
                    </ve-histogram>
                </zm-col>
                <zm-col :span="12" style="height: calc(100vh - 320px)">
                    <ve-histogram :data="chartData2Selected"
                    width="99%" height="100%" :settings="chartSetting" v-if="activeChart === 'topics'" :extend="chartExtend">
                    </ve-histogram>
                    </zm-col>
            </zm-row>
        </div>
    </div>
</template>
<script>
import {
    getPubsub,
    getTopicCount,
    getUserCount,
    getTopics,
    getUsers
} from '../../api/index'
export default {
    name: 'dashboard',
    data () {
        return {
            filter: {
               from: '',
               to: ''
            },
            days: {},
            topicList: [],
            userList: [],
            selectTopic: '',
            selectUser: '',
            activeChart: 'total',
            fromDatePickerOption: {
                disabledDate: (time) => {
                    if (this.filter.to) {
                        const toDate = new Date(Date.parse(this.filter.to))
                        return time.getTime() > toDate || time.getTime() > Date.now()
                    } else {
                        return time.getTime() > Date.now()
                    }
                }
            },
            toDatePickerOption: {
                disabledDate: (time) => {
                    if (this.filter.from) {
                        const fromDate = new Date(Date.parse(this.filter.from))
                        return time.getTime() + 3600 * 1000 * 8 < fromDate || time.getTime() > Date.now()
                    } else {
                        return time.getTime() > Date.now()
                    }
                }
            },
            pickerOptions: {
                disabledDate: this.disabledDate
                // shortcuts: [
                //     {
                //         text: 'today',
                //         onClick (picker) {
                //             const end = new Date()
                //             const start = new Date()
                //             picker.$emit('pick', [start, end])
                //         }
                //     },
                //     {
                //         text: 'last 3 days',
                //         onClick (picker) {
                //             const end = new Date()
                //             const start = new Date()
                //             start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
                //             picker.$emit('pick', [start, end])
                //         }
                //     },
                //     {
                //         text: 'last week',
                //         onClick (picker) {
                //             const end = new Date()
                //             const start = new Date()
                //             start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
                //             picker.$emit('pick', [start, end])
                //         }
                //     }
                // ]
            },
            colors: ['#5ab1ef', '#0067a6', '#19d4ae', '#ffb980', '#fa6e86'],
            chartData: {
                columns: ['label', 'produced', 'producedFailed', 'success', 'failed', 'finalFailed'],
                rows: [
                    { 'label': 'produced', 'produced': 0 },
                    { 'label': 'producedFailed', 'producedFailed': 0 },
                    { 'label': 'success', 'success': 0 },
                    { 'label': 'failed', 'failed': 0 },
                    { 'label': 'finalFailed', 'finalFailed': 0 }
                ]
            },
            daysData: {
                columns: ['label', 'produced', 'producedFailed', 'success', 'failed', 'finalFailed'],
                rows: []
            },
            groupSelected: '',
            chartData2: [],
            chartSetting: {
                label: {
                    show: true
                },
                stack: { 'data': ['produced', 'producedFailed', 'success', 'failed', 'finalFailed'] }
            },
            chartExtend: {
                'xAxis.0.axisLabel.rotate': 45,
                series: {
                    barWidth: 100
                }
            }
        }
    },
    created () {
        localStorage.params = ''
        localStorage.path = this.$route.path
        // if (localStorage.params && localStorage.params !== 'undefined' && localStorage.path === this.$route.path) {
        //     this.filter.from = JSON.parse(localStorage.params).from
        //     this.filter.to = JSON.parse(localStorage.params).to
        // }
        this.fetchData()
    },
    // watch: {
    //     'filter.from' () {
    //         this.setURL()
    //     },
    //     'filter.to' () {
    //         this.setURL()
    //     }
    // },
    computed: {
        chartData2Selected () {
            if (this.groupSelected || this.groupSelected === 0) {
                return this.chartData2[this.groupSelected]
                // return this.chartData2.filter(data => {
                //     return String(data[key]).toLowerCase().indexOf(this.search) > -1
                // })
            }
            return {
                columns: ['label', 'success', 'failed', 'finalFailed'],
                rows: []
            }
        }
    },
    methods: {
        setURL () {
            const { from, to } = this.filter
            const data = { path: this.$route.path, from, to }
            localStorage.params = JSON.stringify(data)
        },
        fetchData () {
            this.daysData.rows = []
            // this.filter.from = this.filter.from.split('T')[0]
            // this.filter.to = this.filter.to.split('T')[0]
            getPubsub(this.filter.from, this.filter.to).then(response => {
                this.chartData.rows.map(row => {
                    row[row.label] = response.total[row.label]
                })
                this.days = Object.keys(response.days)
                this.days.sort()
                this.daysData.rows = []
                this.days.map(day => {
                    const date = day.split('T')[0]
                    this.daysData.rows.push({
                        'label': date,
                        'produced': response.days[day].produced,
                        'producedFailed': response.days[day].producedFailed,
                        'success': response.days[day].success,
                        'failed': response.days[day].failed,
                        'finalFailed': response.days[day].finalFailed
                    })
                })
            })
        },
        fetchTopicData () {
            this.chartData2 = []
            getTopics().then(response => {
                this.topicList = response
                if (this.topicList.length) {
                    if (!this.selectTopic) {
                        this.selectTopic = this.topicList[0].id
                    }
                getTopicCount(this.selectTopic, this.filter.from, this.filter.to).then(response => {
                    this.chartData.rows.map(row => {
                        row[row.label] = response.overall[row.label]
                    })
                    this.chartData2 = []
                    Object.keys(response.groups).map(group => {
                        this.chartData2.push({
                            label: group,
                            columns: ['label', 'success', 'failed', 'finalFailed'],
                            rows: [
                                { 'label': 'success', 'success': response.groups[group]['success'] },
                                { 'label': 'failed', 'failed': response.groups[group]['failed'] },
                                { 'label': 'finalFailed', 'finalFailed': response.groups[group]['finalFailed'] }
                            ]
                        })
                    })
                    this.groupSelected = Object.keys(response.groups)[0] || ''
                })
                }
            })
        },
        fetchUserData () {
            getUsers().then(response => {
                this.userList = response
                if (this.userList.length) {
                    if (!this.selectUser) {
                        this.selectUser = this.userList[0].id
                    }
                    getUserCount(this.selectUser, this.filter.from, this.filter.to).then(response => {
                        this.chartData.rows.map(row => {
                            row[row.label] = response[row.label]
                        })
                    })
                }
            })
        },
        setDate (type) {
            if (type === 0) {
                this.filter.from = new Date()
                this.filter.to = new Date()
            } else if (type === 1) {
                this.filter.from = new Date(new Date().getTime() - 3600 * 1000 * 24 * 2)
                this.filter.to = new Date()
            } else if (type === 2) {
                this.filter.from = new Date(new Date().getTime() - 3600 * 1000 * 24 * 6)
                this.filter.to = new Date()
            }
            this.filter.from = this.filter.from.getFullYear() + '-' + (this.filter.from.getMonth() + 1) + '-' + this.filter.from.getDate()
            this.filter.to = this.filter.to.getFullYear() + '-' + (this.filter.to.getMonth() + 1) + '-' + this.filter.to.getDate()
            this.onDateChange()
        },
        disabledDate (time) {
            return time.getTime() > Date.now()
        },
        onDateChange () {
            this.onChange(this.activeChart)
        },
        onChange (value) {
            if (value === 'topics') {
                this.fetchTopicData()
            } else if (value === 'users') {
                this.fetchUserData()
            } else {
                this.fetchData()
            }
        }
    }
}
</script>
<style scoped>
.date-in-line{
    margin: 10px;
}
.select-chart {
    float: right;
    margin: 10px;
}
.zm-picker-panel *[slot=sidebar].zm-picker-panel__shortcut {
    color: #0E71EB;
    font-size: 16px;
}
.zm-date-editor.zm-input, .zm-date-editor.zm-input__inner {
    width: 150px;
    line-height: 32px;
}
.zm-button-group > .zm-button {
    border-left-color: #0E71EB;
    border-right-color: #0E71EB;
}
.zm-button-group .zm-button--primary:not(:first-child):not(:last-child) {
    border-left-color: #0E71EB;
    border-right-color: #0E71EB;
}
</style>
<style>
/* .zm-radio-group[buttonstyle] .zm-radio .zm-radio__label {
    height: 32px;
    line-height: 16px;
}
.zm-radio-group--small[buttonstyle] .zm-radio .zm-radio__label {
    line-height: 16px;
} */
</style>
